// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-3c6f752d] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.item-list__entry[data-v-3c6f752d] {
  display: flex;
  align-items: center;
  position: relative;
  padding: 8px;
}
.item-list__entry[data-v-3c6f752d]:hover, .item-list__entry[data-v-3c6f752d]:focus {
  background-color: var(--color-background-hover);
  border-radius: var(--border-radius-large);
}
.item-list__entry .item-avatar[data-v-3c6f752d] {
  position: relative;
  margin-top: auto;
  margin-bottom: auto;
}
.item-list__entry .item__details[data-v-3c6f752d] {
  padding-inline-start: 8px;
  max-height: fit-content;
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: var(--default-clickable-area);
}
.item-list__entry .item__details h3[data-v-3c6f752d],
.item-list__entry .item__details .message[data-v-3c6f752d] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item-list__entry .item__details .message span[data-v-3c6f752d] {
  width: 10px;
  display: inline-block;
  margin-bottom: -3px;
}
.item-list__entry .item__details h3[data-v-3c6f752d] {
  font-size: 100%;
  margin: 0;
}
.item-list__entry .item__details .message[data-v-3c6f752d] {
  width: 100%;
  color: var(--color-text-maxcontrast);
}
.item-list__entry .item-icon[data-v-3c6f752d] {
  position: relative;
  width: 14px;
  height: 14px;
  margin-top: 25px;
  margin-inline: -10px -2px;
}
.item-list__entry button.primary[data-v-3c6f752d] {
  padding: 21px;
  margin: 0;
}

/*
.content-popover {
	height: 0px;
	width: 0px;
	margin-inline: auto;
}
.popover-container {
	width: 100%;
	height: 0px;
}
*/`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcDashboardWidgetItem-CAsF_ZMZ.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,+CAA+C;EAC/C,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;AAC3C;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;;;;;;;;CAUC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-3c6f752d] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.item-list__entry[data-v-3c6f752d] {\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 8px;\n}\n.item-list__entry[data-v-3c6f752d]:hover, .item-list__entry[data-v-3c6f752d]:focus {\n  background-color: var(--color-background-hover);\n  border-radius: var(--border-radius-large);\n}\n.item-list__entry .item-avatar[data-v-3c6f752d] {\n  position: relative;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.item-list__entry .item__details[data-v-3c6f752d] {\n  padding-inline-start: 8px;\n  max-height: fit-content;\n  flex-grow: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: var(--default-clickable-area);\n}\n.item-list__entry .item__details h3[data-v-3c6f752d],\n.item-list__entry .item__details .message[data-v-3c6f752d] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.item-list__entry .item__details .message span[data-v-3c6f752d] {\n  width: 10px;\n  display: inline-block;\n  margin-bottom: -3px;\n}\n.item-list__entry .item__details h3[data-v-3c6f752d] {\n  font-size: 100%;\n  margin: 0;\n}\n.item-list__entry .item__details .message[data-v-3c6f752d] {\n  width: 100%;\n  color: var(--color-text-maxcontrast);\n}\n.item-list__entry .item-icon[data-v-3c6f752d] {\n  position: relative;\n  width: 14px;\n  height: 14px;\n  margin-top: 25px;\n  margin-inline: -10px -2px;\n}\n.item-list__entry button.primary[data-v-3c6f752d] {\n  padding: 21px;\n  margin: 0;\n}\n\n/*\n.content-popover {\n\theight: 0px;\n\twidth: 0px;\n\tmargin-inline: auto;\n}\n.popover-container {\n\twidth: 100%;\n\theight: 0px;\n}\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
